import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { trackInternalEvent } from '@rio/tracking'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { actions } from 'builder/modules/ui'

import Menu from './Menu'
import { OpenIcon, CloseIcon, Container, CloseButton } from './styles'

interface IProps {
  isOpen: boolean
  setIsOpen: (prop: boolean) => void
}

export const SideMenu = ({ isOpen, setIsOpen }: IProps) => {
  const width = isOpen ? '240px' : '60px'
  const dispatch = useDispatch()
  const { isTablet } = useMediaQueries()
  const containerRef = useRef<HTMLDivElement>(null)

  const openCloseMenu = () => {
    trackInternalEvent(!isOpen ? 'nav_expanded' : 'nav_collapsed')
    dispatch(actions.setSideMenuOpen(!isOpen))
    setIsOpen(!isOpen)
  }

  useEffect(() => {
    if (isTablet) {
      setIsOpen(false)
    } else {
      setIsOpen(true)
    }
  }, [isTablet])

  return (
    <Container ref={containerRef}>
      <Menu id="side-menu-desktop" width={width} isOpen={isOpen} />

      <CloseButton data-testid="side-menu-toggle" onClick={openCloseMenu}>
        {isOpen ? <CloseIcon data-testid="close-icon" /> : <OpenIcon data-testid="open-icon" />}
      </CloseButton>
    </Container>
  )
}
